import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { ENV } from '../../utils/constants/env';

if (!__DEV__) {
  Sentry.init({
    dsn: 'https://51e4e99741cd4ed7b2fd1c88fc5893f7@o617231.ingest.sentry.io/6024139',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });

  Sentry.configureScope((scope) => {
    scope.setTag('application', 'RN_WEB');
    scope.setTag('application_env', ENV);
  });
}

export default Sentry;
